import { Input as InputAnt } from "antd";

export const TextArea = InputAnt.TextArea;
